import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// react-snap pre-renders pages to static HTML.
// Use hydrateRoot when pre-rendered HTML already exists so React
// attaches event listeners without discarding the markup.
// Fall back to createRoot for pages that were not pre-rendered.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    {
      onRecoverableError(error, errorInfo) {
        console.error('HYDRATION ERROR DETAIL:', error?.message || error, errorInfo?.componentStack);
      }
    }
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
